import React, { useState, useEffect } from 'react';
import axios from 'axios';

function ReviewsPage() {
  // State for reviews list & loading
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  // State for the form
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [comment, setComment] = useState('');
  const [rating, setRating] = useState(5);

  // State for Editing Mode
  const [editingId, setEditingId] = useState(null);

  // --- 1. Fetch Reviews ---
  const fetchReviews = () => {
    setLoading(true);
    axios.get(process.env.REACT_APP_API_BASE_URL + '/reviews')
      .then(res => {
        setReviews(res.data);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchReviews();
  }, []);

  // --- 2. Handle Submit (Add OR Update) ---
  const handleReviewSubmit = (e) => {
    e.preventDefault();
    const reviewData = { name, email, comment, rating };

    if (editingId) {
      // UPDATE EXISTING REVIEW
      axios.put(`${process.env.REACT_APP_API_BASE_URL}+'/reviews/update/${editingId}`, reviewData)
        .then(res => {
          alert('Review updated successfully!');
          resetForm();
          fetchReviews();
        })
        .catch(err => alert('Error updating review.'));
    } else {
      // ADD NEW REVIEW
      axios.post(process.env.REACT_APP_API_BASE_URL + '/reviews/add', reviewData)
        .then(res => {
          alert('Review submitted successfully!');
          resetForm();
          fetchReviews();
        })
        .catch(err => alert('Error submitting review.'));
    }
  };

  // --- 3. Handle Delete ---
  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this review?")) {
      axios.delete(`${process.env.REACT_APP_API_BASE_URL}/reviews/${id}`)
        .then(res => {
          alert("Review deleted.");
          fetchReviews();
        })
        .catch(err => alert("Error deleting review."));
    }
  };

  // --- 4. Handle Edit Click ---
  const handleEdit = (review) => {
    setEditingId(review._id);
    setName(review.name);
    setEmail(review.email);
    setComment(review.comment);
    setRating(review.rating);

    // Scroll to form smoothly
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const resetForm = () => {
    setName('');
    setEmail('');
    setComment('');
    setRating(5);
    setEditingId(null);
  };

  const renderStars = (num) => '⭐'.repeat(num);

  return (
    <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh', paddingBottom: '50px' }}>

      {/* Banner Section */}
      <div className="text-center py-3 text-white" style={{ backgroundColor: '#1c1c1c' }}>
        <h1 className="display-4 fw-normal" style={{ fontSize: '2.5rem' }}>Customer Reviews</h1>
        <p className="lead" style={{ fontSize: '1.1rem', opacity: 0.8 }}>
          See what our clients say about K2 Peak Technologies
        </p>
      </div>

      <div className="container mt-5">

        {/* --- FORM SECTION --- */}
        <div className="row justify-content-center mb-5">
          <div className="col-lg-8">
            <div className="card border-0 shadow-sm p-4 bg-white rounded-3">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h2 className="fw-normal text-dark m-0" style={{ fontSize: '2rem' }}>
                  {editingId ? 'Edit Your Review' : 'Leave a Review'}
                </h2>
                {editingId && (
                  <button className="btn btn-sm btn-outline-secondary" onClick={resetForm}>Cancel Edit</button>
                )}
              </div>

              <form onSubmit={handleReviewSubmit}>
                <div className="mb-3">
                  <input type="text" className="form-control form-control-lg border bg-light" placeholder="Your Name" value={name} onChange={(e) => setName(e.target.value)} style={{ fontSize: '1rem', padding: '12px' }} required />
                </div>
                <div className="mb-3">
                  <input type="email" className="form-control form-control-lg border bg-light" placeholder="Your Email" value={email} onChange={(e) => setEmail(e.target.value)} style={{ fontSize: '1rem', padding: '12px' }} required />
                </div>
                <div className="mb-3">
                  <textarea className="form-control form-control-lg border bg-light" rows="4" placeholder="Write your review..." value={comment} onChange={(e) => setComment(e.target.value)} style={{ fontSize: '1rem', padding: '12px' }} required></textarea>
                </div>
                <div className="mb-4">
                  <label className="form-label fw-bold">Rating:</label>
                  <select className="form-select form-select-lg bg-light" value={rating} onChange={(e) => setRating(Number(e.target.value))}>
                    <option value={5}>⭐⭐⭐⭐⭐ (Excellent)</option>
                    <option value={4}>⭐⭐⭐⭐ (Good)</option>
                    <option value={3}>⭐⭐⭐ (Average)</option>
                    <option value={2}>⭐⭐ (Fair)</option>
                    <option value={1}>⭐ (Poor)</option>
                  </select>
                </div>

                <button
                  type="submit"
                  className={`btn w-100 text-white fw-bold py-3 ${editingId ? 'btn-primary' : 'btn-warning'}`}
                  style={{ fontSize: '1.1rem', borderRadius: '5px', backgroundColor: editingId ? '#0d6efd' : '#fd7e14' }}
                >
                  {editingId ? 'Update Review' : 'Submit Review'}
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* --- REVIEWS LIST SECTION --- */}
        <div className="row justify-content-center">
          <div className="col-12">

            {loading ? (
              <div className="text-center"><div className="spinner-border text-primary"></div></div>
            ) : (
              <div className="row g-4">
                {reviews.map(review => (
                  <div className="col-lg-4 col-md-6" key={review._id}>
                    <div className="card border-0 shadow-sm h-100 bg-white rounded-3 position-relative">

                      {/* --- THREE DOTS MENU (Top Right) --- */}
                      <div className="position-absolute top-0 end-0 mt-3 me-3">
                        <div className="dropdown">
                          <button
                            className="btn btn-light btn-sm rounded-circle shadow-none"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            style={{ width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                          >
                            <i className="bi bi-three-dots-vertical text-muted"></i>
                          </button>
                          <ul className="dropdown-menu dropdown-menu-end shadow border-0">
                            <li>
                              <button className="dropdown-item" onClick={() => handleEdit(review)}>
                                <i className="bi bi-pencil me-2 text-primary"></i> Edit
                              </button>
                            </li>
                            <li>
                              <button className="dropdown-item text-danger" onClick={() => handleDelete(review._id)}>
                                <i className="bi bi-trash me-2"></i> Delete
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                      {/* --------------------------------- */}

                      <div className="card-body p-4 d-flex flex-column pt-5"> {/* Added pt-5 to clear space for the dots */}

                        {/* Header: Name & Stars */}
                        <div className="mb-2">
                          <h5 className="fw-bold mb-1 text-dark" style={{ fontSize: '1.2rem' }}>
                            {review.name}
                          </h5>
                          <div className="text-warning fs-6" style={{ letterSpacing: '1px' }}>
                            {renderStars(review.rating)}
                          </div>
                        </div>

                        {/* Date */}
                        <small className="text-muted mb-3 d-block" style={{ fontSize: '0.85rem' }}>
                          {review.createdAt ? new Date(review.createdAt).toLocaleDateString() : 'Recently'}
                        </small>

                        {/* Comment */}
                        <p className="card-text text-secondary flex-grow-1" style={{ lineHeight: '1.6', fontSize: '0.95rem' }}>
                          "{review.comment}"
                        </p>

                      </div>
                    </div>
                  </div>
                ))}

                {!loading && reviews.length === 0 && (
                  <div className="col-12 text-center">
                    <p className="text-muted">No reviews yet. Be the first to share your experience!</p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

      </div>
    </div>
  );
}

export default ReviewsPage;